import React, {useEffect, useState} from 'react'
import {withRouter} from "react-router-dom"
import '../../../assets/style/getStarted.scss'
import {withStyles} from "@material-ui/core/styles";
import Asciidoctor from "asciidoctor.js/dist/asciidoctor";
import {getStaticResource} from "../../../api/developer";
import BILLoader from "../BILLoader/BILLoader";

const styles = theme => ({
    tab: {
        color: '#702F8A',
        '&:hover': {
            color: 'black'
        },
        '&:focus': {
            boxShadow: 'none',
            outline: 'none'
        },
        fontWeight: 300,
        minWidth: '90px',
        width: '90px'
    },
    indicator: {
        backgroundColor: '#702F8A'
    },
    link: {
        display: 'flex',
        color: '#008577',
        '&:hover': {
            color: 'grey'
        },
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    }
});

const AsciiDoc = (props) => {

    useEffect(() => {
        getStaticResource(staticResource)
            .then(async (res) => await asciidoctor.convert(res.data))
            .then(async (res) => await setAsciiDocHtml(res))
            .then(async () => await setIsLoading(false))
            .then(async () => bindMenu());
    }, []);

    useEffect(() => {
        const asciiDocContent = document.getElementById("asciiDocContent");
        if (asciiDocContent && asciiDocContent.scrollTop === 0) {
            asciiDocContent.scrollTop = 1;
        }
    });

    const {minusDocHeight, staticResource} = props;
    const asciidoctor = Asciidoctor();
    const [isLoading, setIsLoading] = useState(true);
    const [asciiDocHtml, setAsciiDocHtml] = useState("");

    window.addEventListener('resize', function () {
        let currentActiveLi = document.getElementById("li-active");
        if (currentActiveLi) {
            currentActiveLi.style.background = "unset";
            currentActiveLi.style.padding = "unset";
            currentActiveLi.style.marginLeft = "unset";
            currentActiveLi.style.boxShadow = "unset";
            currentActiveLi.style.boxDecorationBreak = "unset";
            currentActiveLi.id = "";
        }
    }, true);

    window.addEventListener('scroll', function () {
        highlightCurrentStep();
    }, true);

    const highlightCurrentStep = () => {
        const asciiDocContent = document.getElementById("asciiDocContent");
        if (asciiDocContent && asciiDocContent.scrollTop >= 0) {
            let highestIndex = 0;
            let asciiDocContent = document.getElementById("asciiDocContent");
            let anchors = document.querySelectorAll("#ascii-content #asciiDocContent a.anchor");

            let links = document.querySelectorAll("#tableContent a");
            anchors.forEach((anchor, index) => {
                const scrollTop = asciiDocContent.scrollTop;
                highestIndex = anchor.offsetTop - 27 < scrollTop ? index : highestIndex;

            });
            links.forEach((link, index) => {
                const linkHref = link.getAttribute("href");
                const anchorHref = anchors && anchors[highestIndex] ? anchors[highestIndex].getAttribute("href") : "";
                if (linkHref === anchorHref) {
                    updateSelectionIfApplicable({target: link});
                }
            });
        }
    }

    const bindMenu = () => {
        if (document.getElementById('toc')) {
            let tableContent = document.querySelector('.sectlevel1').innerHTML || '';
            document.getElementById('toc').remove();
            document.getElementById('tableContent').innerHTML = tableContent;
        }
    }

    const updateSelectionIfApplicable = (event) => {
        if ("A" === event.target.tagName) {
            let currentActiveLi = document.getElementById("li-active");
            if (currentActiveLi) {
                currentActiveLi.style.background = "unset";
                currentActiveLi.style.padding = "unset";
                currentActiveLi.style.marginLeft = "unset";
                currentActiveLi.style.boxShadow = "unset";
                currentActiveLi.style.boxDecorationBreak = "unset";
                currentActiveLi.id = "";
            }

            const target = event.target;
            if (window.innerWidth < 1475 || event.target.innerText.length > 35) {
                    target.id = 'li-active';
                    target.style.background = "#D6D2D8";
                    target.style.boxShadow = "1em 0 0 #D6D2D8, -1em 0 0 #D6D2D8";
                    target.style.boxDecorationBreak = "clone";
                    target.style.padding = " 0.5em 0em";

            } else {
                    target.id = 'li-active';
                    target.style.background = "#D6D2D8";
                    target.style.marginLeft = "-10px";
                    target.style.padding = "10px";
            }
        }
    };

    if (isLoading) {
        return (
            <div className="intl-spinner-container">
                <BILLoader/>
            </div>
        )
    } else {
        return (
            <div style={{background: "white", display: "flex"}} id="ascii-content">
                <div style={{background: "white", height: `calc(100% - ${minusDocHeight})`}} id="ascii-menu-left">
                    <ul id="tableContent"/>
                </div>

                <div style={{height: `calc(100% - ${minusDocHeight})`}} dangerouslySetInnerHTML={{__html: asciiDocHtml}}
                     id="asciiDocContent"/>
            </div>
        );
    }
}

export default (withStyles(styles)(withRouter(AsciiDoc)))
